<template>
  <div
    class="register-form"
    v-show="showRegister"
  >
    <div class="form-header">
      <p>注册</p>
      <div class="form-weixin"></div>
    </div>
    <div class="form-body">
      <div
        class="form-group"
        v-show="showMsg2"
      >
        <div>
          <img
            src="@/assets/img/login/wt.png"
            alt
          />
          <span v-text="msgText2"></span>
        </div>
      </div>
      <div
        class="form-group"
        :class="{ titleMar: !showMsg2 }"
      >
        <input
          type="text"
          class="form-input"
          v-model="form.passportMobile"
          placeholder="请输入手机号"
        />
      </div>
      <div
        class="form-group"
        style="display:flex"
      >
        <input
          type="text"
          class="form-inputcode"
          v-model="form.passportCode"
          placeholder="请输入验证码"
        />
        <button
          class="form-buttoncode"
          v-show="show"
          @click.prevent="getSmsCode"
        >
          获取验证码
        </button>
        <button
          class="form-buttoncode"
          v-show="!show"
        >
          {{ count }} s
        </button>
      </div>
      <div class="img-code">
        <imgCode
          ref="imgcodeRegister"
          @confirm="getRegisterCode"
        ></imgCode>
      </div>
      <div class="form-group">
        <button
          class="form-button"
          @click.prevent="toRegistered"
        >
          注册
        </button>
      </div>
      <p
        class="span"
        @click.prevent="showLoginForm"
      >前去登录</p>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { toRegister, getCode } from "@/requests/user";
import PAGE_API from "@/apis/pageApi";
import imgCode from "_sc/imgCode";
export default {
  components: {
    imgCode
  },
  props: {
    showRegister: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMsg2: false,
      msgText2: "",
      show: true, //显示倒计时
      count: "",
      timer: null,
      form: {
        passportMobile: "",
        passportCode: ""
      }
    };
  },
  methods: {
    ...mapActions(["user/actionSetPhone", "user/actionSetSmsCode"]),
    //验证码倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    showLoginForm() {
      this.$emit("showLoginForm");
    },
    getSmsCode() {
      let re = this.$validateCenter.phoneNum(this.form.passportMobile);
      if (re.res == false) {
        this.msgText2 = re.msg;
        this.showMsg2 = true;
        return false;
      }
      this.$refs.imgcodeRegister.show();
    },
    async getRegisterCode(code) {
      this.codeWrong = "";
      let obj = {
        phone: this.form.passportMobile,
        imgCode: code
      };
      let res = await getCode(obj);
      if (res.code == 200) {
        this.msgText2 = res.msg;
        this.countDown();
        this.$refs.imgcodeRegister.hide();
      } else {
        this.form.code = "";
        this.showMsg2 = true;
        this.msgText2 = res.msg;
      }
    },
    async toRegistered() {
      let re = this.$validateCenter.phoneNum(this.form.passportMobile);
      if (re.res == false) {
        this.msgText2 = re.msg;
        this.showMsg2 = true;
        return false;
      }
      let obj = {
        passportMobile: this.form.passportMobile,
        passportCode: this.form.passportCode
      };
      let res = await toRegister(obj);
      if (res.code == 200) {
        window.timeOutLoginQr();
        this["user/actionSetPhone"](this.form.passportMobile);
        this["user/actionSetSmsCode"](this.form.passportCode);
        this.$router.push({
          path: PAGE_API.register.path
        });
      } else {
        this.msgText2 = res.msg;
        this.showMsg2 = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login-form,
.register-form {
  padding: 20px 30px;
  width: 380px;
  height: 440px;
  border-radius: 3px;
  background-color: #fff;
  // backface-visibility: hidden;
}
// 表单头部
.form-header {
  display: flex;
  justify-content: space-between;
  p {
    font-size: 20px;
    font-weight: bold;
  }
  .form-weixin {
    display: flex;
    .go-weixin {
      padding-left: 8px;
      transform: translateX(5px);
      width: 96px;
      height: 28px;
      background: url(../../assets/img/login/wx.png) no-repeat;
      color: #00c2de;
      line-height: 28px;
      font-weight: bold;
      text-align: left;
    }
    img {
      cursor: pointer;
    }
    img:hover {
      opacity: 0.8;
      transition: opacity 0.2s;
    }
  }
}
// 表单主体
.form-body {
  .form-group {
    width: 100%;
    padding: 10px 0;
    div {
      overflow: hidden;
      width: 100%;
      line-height: 29px;
      background-color: #fdfae6;
      border: 1px solid #ff934c;
      color: #8c8b85;
      text-align: left;
      img {
        float: left;
        margin: 5px 10px;
      }
    }
    // 表单输入框
    .form-input {
      padding-left: 10px;
      // width: 96.5%;
      width: 100%;
      height: 40px;
      border: 1px solid #dcdcdc;
      color: #000;
      outline: none;
      transition: all 0.7s;
    }
    .form-input:focus {
      border: 1px solid #00c2de;
    }
    // 表单按钮
    .form-button {
      width: 100%;
      height: 40px;
      border: none;
      outline: none;
      color: #fff;
      background-color: #0099cc;
      transition: background-color 0.3s;
    }
    .form-button:hover {
      background-color: #28b5d6;
    }
    .form-button:active {
      background-color: #00ccff;
    }
    // 获取验证码输入框
    .form-inputcode {
      padding-left: 10px;
      // width: 69%;
      width: 70%;
      height: 42px;
      border: 1px solid #00c6de;
      color: #000;
      background-color: #ddf8fc;
    }
    // 获取验证码按钮
    .form-buttoncode {
      // width: 29%;
      width: 30%;
      height: 42px;
      border: 1px solid #00c6de;
      background-color: #ddf8fc;
      border-left: none;
      color: #20c6e0;
    }
    .forget {
      position: absolute;
      top: 25px;
      right: 20px;
      // transform: translate(90px, -30px);
      color: rgb(0, 153, 204);
      cursor: pointer;
    }
  }
  // 表单底部
  p {
    color: #abadae;
    text-align: right;
    a:hover {
      color: #00c2de;
    }
  }
  .span {
    position: absolute;
    top: 463px;
    right: 30px;
    margin-bottom: 30px;
    line-height: 20px;
    font-size: 12px;
    color: rgb(171, 173, 174);
    text-align: right;
    cursor: pointer;
  }
  .p-footer {
    line-height: 70px;
    color: #abadae;
    text-align: left;
    img {
      position: absolute;
      width: 20px;
      transform: translate(10px, 25px);
      cursor: pointer;
    }
    img:last-child {
      transform: translate(45px, 27px);
    }
    span {
      float: right;
      color: rgb(0, 153, 204);
      font-size: 14px;
      font-weight: inherit;
      cursor: pointer;
    }
  }
}
.titleMar {
  margin-top: 50px;
}
.btnMar {
  margin-top: 64px;
}
.img-code {
  position: absolute;
  top: 280px;
  right: 10px;
  width: 140px;
  height: 95px;
}
</style>
